import { gsap } from "gsap";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

export default function initVideoMovement() {
  const isPresent = document.querySelector(".hero-round");
  if (!isPresent) {
    return;
  }

  const wrapper = document.querySelector(".whole-page");

  const video = document.querySelector(".hero-round-inner");

  wrapper.addEventListener("mousemove", (e) => {
    var objLeft = $(video).offset().left;
    var objTop = $(video).offset().top;

    // console.log(objLeft, objTop);

    var objCenterX = objLeft + $(video).width() / 2;
    var objCenterY = objTop + $(video).height() / 2;

    const x = (e.pageX - objCenterX) / 20;
    const y = (e.pageY - objCenterY) / 20;

    let moveX = x ? -x : x;
    let moveY = y ? -y : y;

    gsap.to(video, { x: moveX, y: moveY, duration: 1 });
  });

  wrapper.addEventListener("mouseleave", (e) => {
    gsap.to(video, { x: 0, y: 0, duration: 1 });
  });
}
